<ng-container *ngIf="kkmForm">
  <div class="notice">
    <tax-icon name="info"></tax-icon>
    <span data-qa="notice" *ngIf="kkmForm.formKey === 'kkm-inis-register-sing-kkm-annex'">{{
      (kkmForm.fields.isChangingOfd === 'true'
        ? 'kkm.action.register.sign.ofd-changing'
        : 'kkm.action.register.sign'
      ) | translate
    }}</span>
    <span
      data-qa="notice"
      *ngIf="kkmForm.formKey === 'kkm-inis-reregister-sing-kkm-annex'"
      translate
      >kkm.action.register.sign</span
    >
  </div>

  <div class="card" *ngIf="kkmForm && kkmForm.fields">
    <div class="block" data-qa-block="organization-info">
      <span class="block_title" data-qa="block-title">{{
        'kkm.organisation.title' | translate
      }}</span>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="name-title">{{ 'organization.full.name' | translate }}:</span>
        <span data-qa="name">{{ kkmForm.fields.title }}</span>
      </div>
      <div class="ui-kit-layout-columns-2">
        <span data-qa="inn-title">{{ 'cto.info.iin' | translate }}</span>
        <span data-qa="inn">{{ kkmForm.fields.INN }}</span>
      </div>
    </div>

    <hr class="greyline" />

    <div class="block" data-qa-block="kkm-info">
      <span class="block_title" data-qa="block-title">{{ 'kkm.info.title' | translate }}</span>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="kkm-serial-number-title"
          >{{ 'kkm.settings.serial.number' | translate }}:</span
        >
        <span data-qa="kkm-serial-number">{{ kkmForm.fields.kkmSerialNumber }}</span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="kkm-model-title">{{ 'kkm.settings.model' | translate }}:</span>
        <span translate data-qa="kkm-model">{{ kkmForm.fields.kkmModel }}</span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="kkm-year-title">{{ 'kkm.settings.year' | translate }}:</span>
        <span data-qa="kkm-year">{{ kkmForm.fields.kkmYear }}</span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="retail-place-address-title">{{ 'retail.place.address' | translate }}:</span>
        <span translate data-qa="retail-place-address">{{
          kkmForm.fields.retailPlaceAddress?.fullAddress
        }}</span>
      </div>

      <div
        *ngIf="kkmForm.formKey === 'kkm-inis-register-sing-kkm-annex' && kkmForm.fields.kkmRegId"
        class="ui-kit-layout-columns-2"
      >
        <span data-qa="kkm-registration-number-title">{{ 'cto.kkm.rnm' | translate }}</span>
        <span data-qa="kkm-registration-number"> {{ kkmForm.fields.kkmRegId }}</span>
      </div>
    </div>

    <div class="block" *ngIf="selectedTariff" data-qa-block="tariff-info">
      <hr class="greyline" />

      <span class="block_title" translate data-qa="block-title">tariffs.tariff</span>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="tariff-title">{{ 'tariffs.subscribe' | translate }}:</span>
        <span class="tariff-price" data-qa="tariff">
          {{ selectedTariff | tariffPrice | kzCurrency }}
          {{ 'tariffs.period.MONTH' | translate }}
        </span>
      </div>

      <div class="ui-kit-layout-columns-2">
        <span data-qa="connection-type-title">{{ 'tariffs.connection.type' | translate }}:</span>
        <span translate>
          {{
            selectedTariff.connectionType?.connection === 'WIRED'
              ? 'tariffs.connection.type.wired'
              : 'tariffs.connection.type.wireless'
          }}
        </span>
      </div>

      <div class="ui-kit-layout-columns-2" *ngIf="$any(kkmForm.fields).kkmConnectionId">
        <span data-qa="connection-id-title">{{ 'kkm.settings.network.number' | translate }}:</span>
        <span data-qa="connection-id">{{ $any(kkmForm.fields).kkmConnectionId }}</span>
      </div>
    </div>
  </div>

  <div
    class="documents"
    *ngIf="
      (data?.doc?.inisXmlSignature || documentLinkBilling) &&
      kkmForm.formKey === 'kkm-inis-register-sing-kkm-annex'
    "
  >
    <a
      *ngIf="data?.doc?.inisXmlSignature && !kkmForm.fields.isChangingOfd"
      (click)="openDocument(data?.doc?.inisXmlSignature)"
      class="ui-kit-centering-string"
      data-qa-link="inis"
    >
      <tax-icon name="docs" class="icon"></tax-icon>
      {{ 'kkm.registration.document.kgd' | translate }}
    </a>
    <a
      *ngIf="documentLinkBilling"
      [href]="documentLinkBilling"
      data-qa-link="billing"
      target="_blank"
      class="ui-kit-centering-string"
    >
      <tax-icon name="docs" class="icon"></tax-icon>
      {{ 'kkm.registration.document.tariffing' | translate }}
    </a>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" data-qa-button="go-back">
      {{ 'group.back' | translate }}
    </button>
    <div>
      <button
        *ngIf="data"
        data-qa-button="sign-by-eds"
        class="button_blue"
        [taxOpenCertificateModal]="{ data }"
        (signatureGenerated)="setSignature($event)"
        translate
      >
        sign.by.eds.button
      </button>
      <button
        *ngIf="kkmForm.fields?.singBySmsAllowed === 'true'"
        data-qa-button="sign-by-sms"
        class="button_blue"
        (click)="signBySms()"
        translate
      >
        sign.by.sms.button
      </button>
    </div>
  </div>
</ng-container>
